import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { useCountdown } from '../../hooks/useCountdown';
export function AnnouncementBar() {
  const {
    days
  } = useCountdown();
  return <div className="relative z-[60] bg-ink text-canvas" data-id="element-309" data-mp="1j4h4wur0pjhf">
      <Link to="/#saldering" className="mx-auto flex h-10 max-w-[1440px] items-center justify-center gap-2 px-4 text-[13px] sm:text-[14px]" data-id="element-310" data-mp="1o1zjb0nt0qwt">
        <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-volt" aria-hidden="true" data-id="element-311" data-mp="rdt9lzc0z8bo" />
        <span className="truncate" data-id="element-312" data-mp="ve3knqeocoxe">
          De salderingsregeling stopt over <strong className="font-semibold text-volt" data-id="element-313" data-mp="10bn18wyuhdsi">{days} dagen</strong>
          <span className="hidden text-canvas/70 sm:inline" data-id="element-314" data-mp="15bhuh763efgq"> — bekijk wat dat voor jou betekent</span>
        </span>
        <ArrowRightIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-315" data-mp="2bsmsdp9ghmky" />
      </Link>
    </div>;
}